import React from "react";

import AppWrapper from "../../components/cm/AppWrapper";
import CreateLawfirm from "../../components/cm/Dashboard/FullPages/CreateLawfirm";
import SideBarMain from "../../components/cm/SideBarMain";

export default () => {
  return (
    <AppWrapper.WithSidebar sidebar={<SideBarMain />}>
      <CreateLawfirm />
    </AppWrapper.WithSidebar>
  );
};
